import { Component, OnInit,  } from '@angular/core';
import { AuthService } from './../../../services/auth.service';
import { StatisticsService } from './../../../rest/api/statistics.service';
import { SpaceService } from './../../../services/space.service';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import _ from 'lodash';

@Component({
  selector: 'app-statistics-detail',
  templateUrl: './statistics-detail.component.html',
  styleUrls: ['./statistics-detail.component.scss']
})
export class StatisticsDetailComponent implements OnInit {
  loading = true;
  chartLoader = true;
  accessToken: any;
  langShortCode: any;
  statisticDetailData: any;
  spaceData: any;
  spaceId: any;
  impressionChart: any;
  visitChart: any;
  visitorChart: any;
  filter = '';

  constructor(
    public spaceService: SpaceService,
    private authService: AuthService,
    private statisticService: StatisticsService,
    public router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.getStatisticsDetail(this.spaceData.uuid, this.filter);
      }
    });
    this.getStatistics(this.filter);
  }

  getStatistics(data) {
    this.chartLoader = true;
    this.filter = data;
    this.getStatisticsDetail(this.spaceData.uuid, data);
    if (this.filter === '') {
      this.chartLoader =  false;
    }
  }

  getStatisticsDetail(id, filter) {
    this.statisticService.getStatisticsDetail({
      Authorization: this.accessToken,
      spaceId: this.spaceData.uuid,
      filter: filter || undefined
    }).subscribe((response: any) => {
      this.chartLoader = false;
      this.statisticDetailData = response && response.data ? response.data : [];
      if (this.filter !== '') {
        this.statChart(this.statisticDetailData);
      }
      this.loading = false;
    }, err => {
      this.statisticDetailData = [];
      this.chartLoader = false;
    });
  }

  statChart(value) {
    if (value && value.graph && value.graph.impressions && value.graph.impressions.length > 0) {
      const label = value && value.graph && value.graph.impressions ? _.map(value.graph.impressions, 'date') : [];
      const count = value && value.graph && value.graph.impressions ? _.map(value.graph.impressions, 'count') : [];
      const ctx = document.getElementById('impression');
      if (this.impressionChart !== undefined) {
      this.impressionChart.destroy();
      }
      this.impressionChart = new Chart(ctx, {
      type: 'line',
      data: {
          labels: label,
          datasets: [{
              label: 'count',
              backgroundColor: 'transparent',
              borderColor: 'rgba(233, 155, 66)',
              data: count
          }]
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
              left: 5,
              right: 5,
              top: 10,
              bottom: 10
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
          }
          }],
          yAxes: [{
            ticks: {
                display: false
            }
          }]
        }
      }
      });
    }

    if (value && value.graph && value.graph.visitors && value.graph.visitors.length > 0) {
      const label = value && value.graph && value.graph.visitors ? _.map(value.graph.visitors, 'date') : [];
      const count = value && value.graph && value.graph.visitors ? _.map(value.graph.visitors, 'count') : [];
      const ctx = document.getElementById('visits');
      if (this.visitChart !== undefined) {
      this.visitChart.destroy();
      }
      this.visitChart = new Chart(ctx, {
      type: 'line',
      data: {
          labels: label,
          datasets: [{
              label: 'count',
              backgroundColor: 'transparent',
              borderColor: 'rgba(233, 155, 66)',
              data: count
          }]
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
              left: 5,
              right: 5,
              top: 10,
              bottom: 10
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
          }
          }],
          yAxes: [{
            ticks: {
                display: false
            }
          }]
        }
      }
      });
    }

    if (value && value.graph && value.graph.uniqueVisitors && value.graph.uniqueVisitors.length > 0) {
      const label = value && value.graph && value.graph.uniqueVisitors ? _.map(value.graph.uniqueVisitors, 'date') : [];
      const count = value && value.graph && value.graph.uniqueVisitors ? _.map(value.graph.uniqueVisitors, 'count') : [];
      const ctx = document.getElementById('uniqueVisitors');
      if (this.visitorChart !== undefined) {
      this.visitorChart.destroy();
      }
      this.visitorChart = new Chart(ctx, {
      type: 'line',
      data: {
          labels: label,
          datasets: [{
              label: 'count',
              backgroundColor: 'transparent',
              borderColor: 'rgba(233, 155, 66)',
              data: count
          }]
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
              left: 5,
              right: 5,
              top: 10,
              bottom: 10
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
          }
          }],
          yAxes: [{
            ticks: {
                display: false
            }
          }]
        }
      }
      });
    }

  }
}
